module.exports = __webpack_public_path__ + "img/steam_thumb.31f8e205.jpg";